import { contactInfo } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100/70">
      <div className="max-w-[700px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            联系我们
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            {contactInfo.desc}
          </p>
        </div>

        <div className="p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/70">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <a
              href={`mailto:${contactInfo.email}`}
              className="flex items-center gap-4 p-4 rounded-xl bg-accent-50 border border-accent-200/60 hover:bg-accent-100 transition-colors duration-200 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500 text-white shrink-0">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <div className="min-w-0">
                <span className="text-xs text-foreground-400 block">投稿邮箱</span>
                <span className="text-sm font-medium text-foreground-900 truncate block">{contactInfo.email}</span>
              </div>
            </a>

            <div className="flex items-center gap-4 p-4 rounded-xl bg-secondary-50 border border-secondary-200/60">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-500 text-white shrink-0">
                <i className="ri-wechat-line text-lg"></i>
              </div>
              <div className="min-w-0">
                <span className="text-xs text-foreground-400 block">官方微信</span>
                <span className="text-sm font-medium text-foreground-900">{contactInfo.wechat}</span>
              </div>
            </div>
          </div>

          <div className="mt-5 p-4 rounded-xl bg-background-100 border border-background-200/60">
            <div className="flex items-start gap-2">
              <i className="ri-information-line text-accent-500 text-sm mt-0.5 shrink-0"></i>
              <p className="text-xs text-foreground-500 leading-relaxed">{contactInfo.tips}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}